import AbstractCalls from "./AbstractCalls";

class MarketCalls extends AbstractCalls {
  /**
   * Seller creates a new offer.
   * @param {{registrationId:string, askPrice:number, bankAccount:string}} dtoIn
   */
  createOffer(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/createOffer");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * Seller updates an editable field on their offer (currently only bankAccount).
   * @param {{_id:string, bankAccount?:string}} dtoIn
   */
  updateOfferBySeller(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/updateOfferBySeller");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * Cancel an offer (seller cancels their own ACTIVE offer or admin cancels any).
   * @param {{_id:string, reason?:string}} dtoIn
   */
  cancelOffer(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/cancelOffer");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * Public: list active offers visible to buyers for a race.
   * @param {{raceId:string}} body
   */
  listOffers(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/listOffers");
    return AbstractCalls.get(cmdUri, body, options);
  }

  /**
   * Admin / authority / registration editor: drop in-memory public list cache for a race.
   * @param {{ raceId: string }} dtoIn
   */
  invalidateCache(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/invalidateCache");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * Public: get a single offer by id (anonymous projection).
   * @param {{_id:string}} body
   */
  getOffer(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/getOffer");
    return AbstractCalls.get(cmdUri, body, options);
  }

  /**
   * Buyer claims an offer; returns gateway URL to redirect to.
   * @param {{_id:string}} dtoIn
   */
  buyOffer(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/buyOffer");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * Buyer creates a fresh GoPay session for a previously claimed offer (still in PAYING).
   * @param {{_id:string}} dtoIn
   */
  retryPayment(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/retryPayment");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * Admin/authority: apply GoPay payment status without webhook (e.g. mark PAID to settle a PAYING offer).
   * @param {{ offerId: string, paymentStatus: string, paymentSubState?: string|null }} dtoIn
   */
  processPayment(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/processPayment");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * Authenticated: own offers (seller scope).
   */
  myOffers(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/myOffers");
    return AbstractCalls.get(cmdUri, body, options);
  }

  /**
   * Authenticated: own purchases (buyer scope).
   */
  myPurchases(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/myPurchases");
    return AbstractCalls.get(cmdUri, body, options);
  }

  /**
   * Admin: list all offers for a race (admin projection, ignores publishTs / cache).
   * @param {{raceId:string}} body
   */
  listAllOffers(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/listAllOffers");
    return AbstractCalls.get(cmdUri, body, options);
  }

  /**
   * Admin: settle an ACTIVE offer without a buyer (offline private resale).
   * @param {{_id:string, reason?:string}} dtoIn
   */
  refundOffer(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/refundOffer");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * Admin: toggle manual ops flag that seller credit-note / payout follow-up is done.
   * @param {{_id:string, handled:boolean}} dtoIn
   */
  setCreditNoteHandled(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/setCreditNoteHandled");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }

  /**
   * Admin: delete an offer document; default only allowed on CANCELLED, force purges any state.
   * @param {{_id:string, forcePurge?:boolean}} dtoIn
   */
  deleteOffer(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "market/deleteOffer");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }
}

export default new MarketCalls();
